<a
  *ngIf="!useRelativeLinks && event && useLink"
  [href]="getGameLink(event._id, event.teams.home.teamid)"
  [target]="openLinksInNewTab ? '_blank' : '_self'"
  [class.highlight-on-hover]="highlightOnHover"
  [class.highlight]="highlightGame"
  class="game-item {{ colorScheme?.main }}"
  draggable="false"
>
  <ng-template [ngTemplateOutlet]="matchElement"></ng-template>
</a>
<a
  *ngIf="useRelativeLinks && event && useLink"
  [routerLink]="getGameLink(event._id, event.teams.home.teamid)"
  [href]="getGameLink(event._id, event.teams.home.teamid)"
  [target]="openLinksInNewTab ? '_blank' : '_self'"
  [class.highlight-on-hover]="highlightOnHover"
  [class.highlight]="highlightGame"
  class="game-item {{ colorScheme?.main }}"
  draggable="false"
>
  <ng-template [ngTemplateOutlet]="matchElement"></ng-template>
</a>
<span
  *ngIf="!useLink"
  class="game-item {{ colorScheme?.main }} {{
    highlightOnHover ? '' : 'no-hover'
  }}"
  [class.has-footer-content]="hasFooter"
  draggable="false"
>
  <ng-template [ngTemplateOutlet]="matchElement"></ng-template>
</span>
<ng-template #matchElement>
  <div class="game-item__header">
    <div class="live-status" *ngIf="event.isActive() && !inline">
      <div class="live"></div>
      LIVE
    </div>
  </div>
  <div class="game-item__teams">
    <div class="game-item__team left" [class.centered]="teamNameCentered">
      <span *ngIf="!useAbbreviations">{{
        prepareTeamName(event.teams.home.name)
      }}</span>
      <span *ngIf="useAbbreviations">{{ event.teams.home.abbreviation }}</span>
      <img
        *ngIf="showImages"
        alt="Home team"
        [lazyLoad]="lazyLoadImages"
        draggable="false"
        [src]="
          event.teams.home.pictures | imageUrlBySubtype: logoType : logoSize
        "
      />
    </div>
    <div
      class="game-item__inner"
      [class.highlight-data]="hasBackground()"
      [class.live-data]="event.isActive() && displayStatusBackground"
    >
      <div
        class="game-item__data"
        [ngStyle]="{
          background:
            infoBackground && !event.isPreGame() ? infoBackground : null
        }"
      >
        <span class="game-item__minute" *ngIf="live && minute && !inline">
          {{ minute }}
        </span>
        <span class="data-small round" *ngIf="showRound">
          {{ event.round?.ui_name }}
        </span>

        <span class="data-small" *ngIf="showDate && !event.isActive()">
          {{ event.timestamps.start | date: 'EEE dd.MM.' : null : 'de-DE' }}
        </span>
        <span *ngIf="event.isPreGame()" class="time">{{
          event.timestamps.start | date: 'HH:mm'
        }}</span>

        <ng-container *ngIf="event.isInAutoMode()">
          <span class="time">{{ event.timestamps.start | date: 'HH:mm' }}</span>
        </ng-container>
        <ng-container *ngIf="event.isActive() || event.isPostGameOrCancelled()">
          <div class="score" *ngIf="!event.isCancelledOrAborted()">
            {{ score }}
          </div>
          <span
            class="data-small"
            *ngIf="event.isPostGame() || event.isCancelledOrAborted()"
            [class.canceled]="event.isCancelledOrAborted()"
          >
            {{ getEventStatusString() }}
          </span>
        </ng-container>
      </div>
      <div
        *ngIf="live && minute && inline"
        class="live-status-bar"
        [class.pulse]="event.isOvertime() || event.isPenalty()"
      >
        <div class="progress" [style.width]="progress + '%'"></div>
      </div>
      <div
        *ngIf="showStatus && liveStreamStatus"
        class="status-chip"
        [style.background-color]="liveStreamStatusColor"
      >
        {{ liveStreamStatus }}
      </div>
    </div>
    <div class="game-item__team right" [class.centered]="teamNameCentered">
      <img
        *ngIf="showImages"
        alt="Away team"
        [lazyLoad]="lazyLoadImages"
        draggable="false"
        [src]="
          event.teams.away.pictures | imageUrlBySubtype: logoType : logoSize
        "
      />
      <span *ngIf="!useAbbreviations">{{
        prepareTeamName(event.teams.away.name)
      }}</span>
      <span *ngIf="useAbbreviations">{{ event.teams.away.abbreviation }}</span>
    </div>
    <div
      *ngIf="showDownloads"
      class="actions"
      (click)="$event.stopPropagation(); $event.preventDefault()"
    >
      <mat-spinner
        *ngIf="download?.pending || download?.currentState"
        diameter="20"
        color="primary"
      ></mat-spinner>
      <button mat-icon-button (click)="onCopyLink()">
        <mat-icon>share</mat-icon>
      </button>
      <!--Internal video link-->
      <button
        *ngIf="replayDownloadLink && browserDownload"
        mat-icon-button
        target="_blank"
        rel="noopener noreferrer"
        [matTooltip]="
          downloadedUrls.includes(replayDownloadLink)
            ? 'Erneut herunterladen'
            : 'Replay herunterladen'
        "
        (click)="onBrowserDownload($event)"
      >
        <mat-icon>{{
          downloadedUrls.includes(replayDownloadLink) ? 'refresh' : 'download'
        }}</mat-icon>
      </button>
      <!--Normal download-->
      <button
        *ngIf="
          replayDownloadLink &&
          !browserDownload &&
          (!download || download?.canDownload())
        "
        mat-icon-button
        matTooltip="Replay herunterladen"
        (click)="onDownload($event)"
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        *ngIf="download?.finished"
        mat-icon-button
        matTooltip="Erneut herunterladen"
        (click)="onDownload($event)"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <button
        *ngIf="download?.currentState"
        mat-icon-button
        matTooltip="Download abbrechen"
        (click)="onCancelDownload($event)"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <ng-content select="[suffixContent]"></ng-content>
  </div>
  <div
    class="game-item__league"
    *ngIf="showLeagueInfo && !download?.currentState"
  >
    <span>{{ event.league_info.league_name }}</span>
  </div>
  <ng-content select="[footerContent]"></ng-content>
  <div *ngIf="download?.currentState" class="download-status">
    <div class="download-progress">
      <small>Wird heruntergeladen: {{ downloadState?.speedMBs }} MB/s</small>
      <small
        >{{ downloadState?.loadedMB }} / {{ downloadState?.totalMB }} MB</small
      >
    </div>
    <mat-progress-bar
      [mode]="downloadState?.status === 'PENDING' ? 'query' : 'determinate'"
      [value]="downloadState?.progress"
    ></mat-progress-bar>
  </div>
</ng-template>
